import React,{useEffect,useRef} from "react";
import "./StockGraph.scss";
import Chart from "chart.js";
import {numberFormat} from "../../util";
import moment from "moment";
import { Line } from 'react-chartjs-2';


const StockGraph = (props) => {
	const chartRef = useRef(null);
	const chartParentRef = useRef(null);

	const {xaxis, yaxis, color, sparkline, graph_filter,graph_loading} = props;


	useEffect(() => {
		// returned function will be called on component unmount
		return () => {
			if(document.getElementById("chartjs-tooltip")){
				document.getElementById("chartjs-tooltip").style.opacity = 0;
			}
		}
	}, [])

	useEffect(() => {

		Chart.plugins.register({
			afterDraw: function(chart) {
				if (chart.data.datasets[0].data.length === 0) {
					// No data is present
					var ctx = chart.chart.ctx;
					var width = chart.chart.width;
					var height = chart.chart.height
					chart.clear();

					ctx.save();
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.font = "16px normal 'Helvetica Nueue'";
					var text = graph_loading === true ? 'Loading...':sparkline === true?'':'No data to display'
					ctx.fillText(text, width / 2, height / 2);
					ctx.restore();
				}
			}
		});

		return () => {
			// debugger

			//
			// console.log(chartRef.current);
			// if(chartRef.current){
			//     chartRef.current.destroy();
			// }
		}


		// var ctx = document.getElementById('myChart').getContext('2d');
		// var gradient = ctx.createLinearGradient(0, 0, 0, 150);
		// // background: linear-gradient(180.28deg, rgba(171, 142, 245, 0.2) 0.38%, rgba(171, 142, 245, 0) 75.31%);
		//
		// gradient.addColorStop(0, hexToRgbA(color,0.2));
		// gradient.addColorStop(1, hexToRgbA(color,0));
		//
		//  var myChart = new Chart(ctx, {
		//     type: 'line',
		//     data: {
		//         labels: xaxis,
		//         datasets: [{
		//             // label: '# of Votes',
		//             file:true,
		//             data: yaxis,
		//             backgroundColor: gradient,
		//             borderColor: [
		//                 color,
		//             ],
		//             borderWidth: 1,
		//             pointBackgroundColor:'#F1C144',
		//             pointRadius: 0,
		//             pointHoverRadius: 8,
		//             lineTension: 0,
		//         }]
		//     },
		//     options: {
		//         responsive: true,
		//         maintainAspectRatio: false,
		//         bezierCurve : false,
		//         aspectRatio: 1,
		//         plugins: {
		//             crosshair: {
		//                 line: {
		//                     color: '#F66',  // crosshair line color
		//                     width: 10       // crosshair line width
		//                 },
		//
		//             }
		//         },
		//         tooltips: {
		//             mode: 'index',
		//             intersect: false,
		//             enabled: false,
		//             position: 'average',
		//             custom: function(tooltipModel) {
		//                 // Tooltip Element
		//                 var tooltipEl = document.getElementById('chartjs-tooltip');
		//
		//                 // Create element on first render
		//                 if (!tooltipEl) {
		//                     tooltipEl = document.createElement('div');
		//                     tooltipEl.id = 'chartjs-tooltip';
		//                     tooltipEl.innerHTML = '<table></table>';
		//                     document.body.appendChild(tooltipEl);
		//                 }
		//
		//                 // Hide if no tooltip
		//                 // var tooltipModel = tooltipModel;
		//                 if (tooltipModel.opacity === 0) {
		//                     tooltipEl.style.opacity = 0;
		//                     return;
		//                 }
		//
		//                 // Set caret Position
		//                 tooltipEl.classList.remove('above', 'below', 'no-transform');
		//                 // tooltipEl.classList.remove("top", "bottom", "center", "left", "right");
		//
		//                 if (tooltipModel.yAlign) {
		//                     tooltipEl.classList.add(tooltipModel.yAlign);
		//                 } else {
		//                     tooltipEl.classList.add('no-transform');
		//                 }
		//
		//                 function getBody(bodyItem) {
		//                     return bodyItem.lines;
		//                 }
		//
		//                 // Set Text
		//                 if (tooltipModel.body) {
		//                     var titleLines = tooltipModel.title || [];
		//                     var bodyLines = tooltipModel.body.map(getBody);
		//
		//                     var innerHtml = '<thead>';
		//
		//                     bodyLines.forEach(function (title) {
		//                         innerHtml += '<tr><th><div class="graph-stock-price">' + numberFormat(title) + "</div></th></tr>";
		//                     });
		//                     innerHtml += '</thead><tbody>';
		//
		//                     titleLines.forEach((body, i) => {
		//                         innerHtml += `<tr><td><div class="graph-date">`+moment(body).format("h:mm A Do MMM")+`</div></td></tr>`;
		//                     });
		//                     innerHtml += '</tbody>';
		//
		//                     var tableRoot = tooltipEl.querySelector('table');
		//                     tableRoot.innerHTML = innerHtml;
		//                 }
		//
		//                 var position = this._chart.canvas.getBoundingClientRect();
		//                 const { height, width } = tooltipEl.getBoundingClientRect();
		//                 // Chart canvas positions
		//                 const positionY = this._chart.canvas.offsetTop;
		//                 const positionX = this._chart.canvas.offsetLeft;
		//                 // Carets
		//                 const caretY = tooltipModel.caretY;
		//                 const caretX = tooltipModel.caretX;
		//
		//                 // Final coordinates
		//                 let top = positionY + caretY - height;
		//                 let left = positionX + caretX - width / 2;
		//                 let space = 8; // This for making space between the caret and the element.
		//                 const yAlign = tooltipModel.yAlign;
		//                 const xAlign = tooltipModel.xAlign;
		//                 // yAlign could be: `top`, `bottom`, `center`
		//                 if (yAlign === "top") {
		//                     top += height + space;
		//                 } else if (yAlign === "center") {
		//                     top += height / 2;
		//                 } else if (yAlign === "bottom") {
		//                     top -= space;
		//                 }
		//                 // xAlign could be: `left`, `center`, `right`
		//                 if (xAlign === "left") {
		//                     left = left + width / 2 - tooltipModel.xPadding - space / 2;
		//                     if (yAlign === "center") {
		//                         left = left + space * 2;
		//                     }
		//                 } else if (xAlign === "right") {
		//                     left -= width / 2;
		//                     if (yAlign === "center") {
		//                         left = left - space;
		//                     } else {
		//                         left += space;
		//                     }
		//                 }
		//                 tooltipEl.style.top = `${top}px`;
		//                 tooltipEl.style.left = `${left}px`;
		//
		//                 // var bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);
		//
		//                 // Display, position, and set styles for font
		//                 tooltipEl.style.opacity = 1;
		//                 tooltipEl.style.position = 'absolute';
		//
		//
		//
		//                 // tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
		//                 // tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
		//                 // tooltipEl.style.font = bodyFont.string;
		//                 tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
		//                 tooltipEl.style.pointerEvents = 'none';
		//             }
		//
		//         },
		//         hover: {
		//             mode: 'nearest',
		//             intersect: false
		//         },
		//         elements: {
		//             point:{
		//                 radius: 0
		//             },
		//             line: {
		//                 tension: 0
		//             }
		//         },
		//         legend: {
		//             display: false
		//         },
		//         scales: {
		//             y: {
		//                 beginAtZero: true,
		//                 position: 'right',
		//             },
		//             xAxes: [{
		//                 type: 'time',
		//                 ticks: {
		//                     display: true,
		//                     autoSkip: true,
		//                     maxTicksLimit: 5,
		//                     fontSize: 10,
		//                     fontWeight:400,
		//                     color: '#717178',
		//                     fontFamily:'Inter, sans-serif',
		//                     maxRotation: 0,
		//                     minRotation: 0,
		//                     // labelOffset: 20,
		//
		//                 },
		//                 time: {
		//                     parser: 'YYYY-MM-DD HH:mm:ss',
		//                     unit: graph_filter === '1day'?'hour':'day',
		//                     displayFormats: {
		//                         day: 'DD/MM',
		//                         hour: 'hh:mm A'
		//                     },
		//
		//                 },
		//                 gridLines: {
		//                     display:false,
		//                     offsetGridLines: true
		//                     // offsetGridLines: true
		//                 },
		//             }],
		//             yAxes: [{
		//                 ticks: {
		//                     display: true,
		//                     beginAtZero: true
		//                 },
		//                 gridLines: {
		//                     display:false,
		//                 },
		//             }],
		//         },
		//         layout:{
		//             padding:0
		//         },
		//
		//
		//     }
		// });


	},[]);
	const hexToRgbA = (hex,opacity) => {
		var c;
		if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
			c= hex.substring(1).split('');
			if(c.length=== 3){
				c= [c[0], c[0], c[1], c[1], c[2], c[2]];
			}
			c= '0x'+c.join('');
			return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
		}
		throw new Error('Bad Hex');
	}
	const data = canvas => {
		const ctx = canvas.getContext('2d');
		var gradient = ctx.createLinearGradient(0, 0, 0, 150);
		gradient.addColorStop(0, hexToRgbA(color,0.2));
		gradient.addColorStop(1, hexToRgbA(color,0));

		return {
			labels: xaxis,
			datasets: [{
				// label: '# of Votes',
				file:true,
				data: yaxis,
				backgroundColor: gradient,
				borderColor: [
					color,
				],
				borderWidth: 1,
				pointBackgroundColor:'#F1C144',
				pointRadius: 0,
				pointHoverRadius: 8,
				lineTension: 0,
			}]
		};
	}

	const option = {
		responsive: true,
		maintainAspectRatio: false,
		bezierCurve : false,
		aspectRatio: 1,
		plugins: {
			crosshair: {
				line: {
					color: '#F66',  // crosshair line color
					width: 10       // crosshair line width
				},

			}
		},
		tooltips: {
			mode: 'index',
			intersect: false,
			enabled: false,
			position: 'average',

			custom: function(tooltipModel) {
				// Tooltip Element
				var tooltipEl = document.getElementById('chartjs-tooltip');

				// Create element on first render
				if (!tooltipEl) {
					tooltipEl = document.createElement('div');
					tooltipEl.id = 'chartjs-tooltip';
					tooltipEl.innerHTML = '<table></table>';
					if(chartParentRef.current){
						chartParentRef.current.appendChild(tooltipEl);
					}
				}

				// Hide if no tooltip
				// var tooltipModel = tooltipModel;
				if (tooltipModel.opacity === 0) {
					tooltipEl.style.opacity = 0;
					return;
				}

				// Set caret Position
				tooltipEl.classList.remove('above', 'below', 'no-transform');
				// tooltipEl.classList.remove("top", "bottom", "center", "left", "right");

				if (tooltipModel.yAlign) {
					tooltipEl.classList.add(tooltipModel.yAlign);
				} else {
					tooltipEl.classList.add('no-transform');
				}

				function getBody(bodyItem) {
					return bodyItem.lines;
				}

				// Set Text
				if (tooltipModel.body) {
					var titleLines = tooltipModel.title || [];
					var bodyLines = tooltipModel.body.map(getBody);

					var innerHtml = '<thead>';

					bodyLines.forEach(function (title) {
						innerHtml += '<tr><th><div class="graph-stock-price">' + numberFormat(title) + "</div></th></tr>";
					});
					innerHtml += '</thead><tbody>';

					titleLines.forEach((body, i) => {
						innerHtml += `<tr><td><div class="graph-date">`+moment(body).format("h:mm A Do MMM")+`</div></td></tr>`;
					});
					innerHtml += '</tbody>';

					var tableRoot = tooltipEl.querySelector('table');
					tableRoot.innerHTML = innerHtml;
				}

				var position = this._chart.canvas.getBoundingClientRect();
				const { height, width } = tooltipEl.getBoundingClientRect();
				// Chart canvas positions
				const positionY = this._chart.canvas.offsetTop;
				const positionX = this._chart.canvas.offsetLeft;
				// Carets
				const caretY = tooltipModel.caretY;
				const caretX = tooltipModel.caretX;

				// Final coordinates
				let top = positionY + caretY - height;
				let left = positionX + caretX - width / 2;
				let space = 8; // This for making space between the caret and the element.
				const yAlign = tooltipModel.yAlign;
				const xAlign = tooltipModel.xAlign;
				// yAlign could be: `top`, `bottom`, `center`
				if (yAlign === "top") {
					top += height + space;
				} else if (yAlign === "center") {
					top += height / 2;
				} else if (yAlign === "bottom") {
					top -= space;
				}
				// xAlign could be: `left`, `center`, `right`
				if (xAlign === "left") {
					left = left + width / 2 - tooltipModel.xPadding - space / 2;
					if (yAlign === "center") {
						left = left + space * 2;
					}
				} else if (xAlign === "right") {
					left -= width / 2;
					if (yAlign === "center") {
						left = left - space;
					} else {
						left += space;
					}
				}
				tooltipEl.style.top = `${top}px`;
				tooltipEl.style.left = `${left}px`;

				// var bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

				// Display, position, and set styles for font
				tooltipEl.style.opacity = 1;
				tooltipEl.style.position = 'absolute';



				// tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
				// tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
				// tooltipEl.style.font = bodyFont.string;
				tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
				tooltipEl.style.pointerEvents = 'none';
			}

		},
		hover: {
			mode: 'nearest',
			intersect: false
		},
		elements: {
			point:{
				radius: 0
			},
			line: {
				tension: 0
			}
		},
		legend: {
			display: false
		},
		scales: {
			y: {
				beginAtZero: true,
				position: 'right',
			},
			xAxes: [{
				type: 'time',
				ticks: {
					display: true,
					autoSkip: true,
					maxTicksLimit: 5,
					fontSize: 10,
					fontWeight:400,
					color: '#717178',
					fontFamily:'Inter, sans-serif',
					maxRotation: 0,
					// minRotation: 0,
					// labelOffset: 20,

				},
				time: {
					parser: 'YYYY-MM-DD HH:mm:ss',
					unit: graph_filter === '1day'?'hour':'day',
					displayFormats: {
						day: 'DD/MM',
						hour: 'hh:mm A'
					},

				},
				gridLines: {
					display:false,
					offsetGridLines: true,


					// offsetGridLines: true
				},
			}],
			yAxes: [{
				ticks: {
					display: false,
					beginAtZero: true
				},
				gridLines: {
					display:false,
				},
			}],
		},
		layout:{
			// padding:0
			padding: {
				top: 20,
			}
		},
	}

	return(
		<div className={"stock-graph-component"} ref={chartParentRef}>
			{/*<canvas id="myChart" width="100%"  height={170}/>*/}
			<Line
				ref={chartRef}
				height={170}
				// width={100}
				data={data}
				redraw={true}
				options={option}
				id={"myChart"}
			/>
		</div>
	);
}

export default StockGraph;
